import * as React from 'react';
import { TextInput, Textarea } from "soprasteria-ui-library";
import { IReferral } from '../../../models/IReferral';
import { dateTimeToDateString } from '../../../helpers/DateHelper';

interface IReferralInformation {
    referral?: IReferral;
    manualRegistration?: boolean;
}

export const ReferralInformation: React.FunctionComponent<IReferralInformation> = ({ referral, manualRegistration }) => {

    return (
        <div className="row readonly-less-margin">
            <h5 className="col-12">Remissinformation</h5>
            <div className="col-6">
                <Textarea rows={6} name="referralReason" label="Remissorsak" defaultValue={referral?.referralReason ? referral?.referralReason : ""} maxLength={5000} required={referral?.isEditable || manualRegistration} inlineLabel readonly={!referral?.isEditable && !manualRegistration} />
            </div>
            <div className="col-6">
                <Textarea rows={6} name="referralText" label="Remisstext" defaultValue={referral?.referralText ? referral?.referralText : ""} maxLength={5000} required={referral?.isEditable || manualRegistration} inlineLabel readonly={!referral?.isEditable && !manualRegistration} />
            </div>
            {
                referral?.referralAnswer || referral?.canWriteAnswer ?
                    <div className="col-6">
                        <Textarea rows={6} name="comment" label="Remissvar" defaultValue={referral?.referralAnswer} maxLength={5000} required inlineLabel readonly={!(referral?.canWriteAnswer)} />
                    </div>
                    : null
            }
        </div >
    )
}